import Vue from "vue";
import VueNotification from '@mathieustan/vue-notification';

Vue.use(VueNotification);

export default {
    methods: {
        showNotification(data) {
            let defaultData = {
                top: true,
                right: true,
                showClose: true,
                multiLine: true,
                closeDelay: 4000,
                theme: {
                    colors: {
                        success: '#54d861',
                        darkenSuccess: '#2d8e36',
                        info: '#5d6a89',
                        darkenInfo: '#535f7b',
                        warning: '#f8a623',
                        darkenWarning: '#f69a07',
                        error: '#ff4577',
                        darkenError: '#ff245f',
                        offline: '#ff4577',
                        darkenOffline: '#ff245f',
                    }
                }
            }

            const notificationOptions = Object.assign(defaultData, data);
            this.$notify(notificationOptions);

            setTimeout(function () {
                var
                    notificationContentSelector = ".notification .notification__wrapper .notification__content",
                    notificationContent = document.querySelector(notificationContentSelector);

                if (notificationContent) {
                    notificationContent.setAttribute('role', 'alert');
                    notificationContent.setAttribute('aria-live', 'polite');
                    notificationContent.setAttribute('tabindex', 0);
                    notificationContent.focus();

                    var notificationCloseBtn = notificationContent.querySelector(".notification__close");
                    if (notificationCloseBtn) {
                        notificationCloseBtn.setAttribute('aria-label', 'Notification Close');
                    }
                }
                $('.notification__icon > svg').attr('aria-label', 'Notification Message Icon');
                $('.notification__close > svg').attr('aria-label', 'Notification Close Icon');
            }, 100);
        }
    }
};